import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import EscolaridadeService from "./escolaridadeService"
import FormList from 'base/FormList'

export default function EscolaridadeList() {

    const [service] = useState(() => new EscolaridadeService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_esco',
        dsName: 'descricao_esco',
        mainField: { name: 'descricao_esco', label: 'Descrição' },
        advFields: [
            { name: 'codigo_esco', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_esco', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_esco" sortable header="Descrição"></Column>
        </FormList >
    )
}
